import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {
  ShopSellerBatchChangeHistoryModel, ShopSellerEntityChangeHistoryModel,
  ShopSellerInformationModel,
  ShopSellerListFilterModel,
  ShopSellerListItem
} from '../../models/shop-seller/shop-seller.model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Pageable} from '../../models/common/pageable.model';
import {Observable} from 'rxjs';
import {GanSellerBatchItem} from '../../models/shop-seller/shop-seller-gan.model';

@Injectable({
  providedIn: 'root'
})
export class ShopSellerService {
  private readonly baseUrl: string = `${environment.backend.url}/api/vtex/shop-seller/v1`;

  constructor(private readonly http: HttpClient) {
  }

  /** `id` is the numeric seller id (database source) or the master data document id (master data source). */
  getSellerById(id: number | string): Observable<ShopSellerInformationModel> {
    return this.http.get<ShopSellerInformationModel>(`${this.baseUrl}/by-id/${id}`);
  }

  getSellerList(filter: ShopSellerListFilterModel) {
    let params = new HttpParams()
      .set('page', filter.page.toString())
      .set('pageSize', filter.pageSize.toString());

    if (filter.documentId) {
      params = params.set('documentId', filter.documentId);
    }
    if (filter.name) {
      params = params.set('name', filter.name);
    }
    if (filter.email) {
      params = params.set('email', filter.email);
    }
    if (filter.login) {
      params = params.set('login', filter.login);
    }
    if (filter.authorized !== undefined) {
      params = params.set('authorized', String(filter.authorized));
    }

    return this.http.get<Pageable<ShopSellerListItem>>(`${this.baseUrl}/search`, {params});
  }

  postSyncSeller(idSeller: number) {
    return this.http.post(`${this.baseUrl}/synchronize/get-vtex-id/${idSeller}`, {});
  }

  postCreateVtexSeller(idSeller: number, body: GanSellerBatchItem) {
    return this.http.post(`${this.baseUrl}/synchronize/create/${idSeller}`, body);
  }

  putUpdateVtexSeller(idSeller: number | string, body: GanSellerBatchItem) {
    return this.http.put(`${this.baseUrl}/synchronize/update/${idSeller}`, body);
  }

  deleteVtexSeller(idSeller: number | string) {
    return this.http.delete(`${this.baseUrl}/synchronize/delete/${idSeller}`);
  }

  getVtexSellerEntityHistory(email: string, page: number, pageSize: number) {
    const params = new HttpParams()
      .set('email', email)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<Pageable<ShopSellerEntityChangeHistoryModel>>(`${this.baseUrl}/history`, {params});
  }

  getVtexSellerBatchHistory(email: string, page: number, pageSize: number) {
    const params = new HttpParams()
      .set('email', email)
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());
    return this.http.get<Pageable<ShopSellerBatchChangeHistoryModel>>(`${this.baseUrl}/batch/history`, {params});
  }
}
